import { useState, type ReactNode } from "react";

import { t } from "../../lib/i18n";

import { Modal } from "./Modal";

interface GlossaryProps {
  /** Locale key prefix under `glossary.*`. */
  termKey: string;
  /** Visible inline label (defaults to glossary term title). */
  label?: ReactNode;
}

/**
 * Inline `?` icon that pops a modal explaining a Govern term in plain
 * language. Locale keys: `glossary.{termKey}.title` and `glossary.{termKey}.body`.
 */
export function Glossary({ termKey, label }: GlossaryProps) {
  const [open, setOpen] = useState(false);
  const title = t(`glossary.${termKey}.title`);
  const body = t(`glossary.${termKey}.body`);

  return (
    <>
      <button
        type="button"
        className="glossary-trigger"
        aria-label={typeof label === "string" ? label : title}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
      >
        {label ?? <span aria-hidden="true">?</span>}
      </button>
      <Modal open={open} onClose={() => setOpen(false)} title={title}>
        <p style={{ margin: 0, lineHeight: 1.55, whiteSpace: "pre-wrap" }}>{body}</p>
      </Modal>
    </>
  );
}
